import { Box, Stack } from "@mui/material"
import { SearchBoxUsingSearchParam } from "lib/@components/searchBoxUsingSearchParam.js"
import { StandardCombo } from "lib/@components/combos/standardCombo.js"
import { useSearchParam } from "lib/@hooks/use-search-param.js"
import { useBoundContext } from "lib/@components/binding/use-bound-context.js"
import { setFromEvent } from "lib/setFromEvent"
import { STATUS_OPTIONS } from "routes/asset-register/plugins/asset-mapping/ai-type-review/type-review-constants"
import noop from "lib/noop"

export function TypeReviewSearch({ children }) {
    const [filter] = useSearchParam("filter", "all")
    const { setFilter = noop } = useBoundContext()

    return (
        <Stack
            direction={{ xs: "column", lg: "row" }}
            spacing={1.5}
            alignItems={{ xs: "stretch", lg: "center" }}
            justifyContent="space-between"
            sx={{ py: 1 }}
        >
            <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={1}
                alignItems={{ xs: "stretch", sm: "center" }}
                sx={{ flex: 1, minWidth: 0 }}
            >
                <SearchBoxUsingSearchParam
                    textFieldProps={{ variant: "outlined", size: "small" }}
                    py={0.5}
                    flex={1}
                    minWidth={0}
                    placeholder="Search..."
                />
                <Box>
                    <StandardCombo
                        label="Status"
                        size="small"
                        fullWidth={false}
                        value={filter}
                        onChange={setFromEvent(setFilter)}
                        sx={{ width: 140 }}
                        options={STATUS_OPTIONS}
                    />
                </Box>
            </Stack>
            <Box sx={{ display: "flex", justifyContent: { xs: "flex-start", lg: "flex-end" } }}>{children}</Box>
        </Stack>
    )
}
